// パスパラメータ用のテンプレートリテラルを返却する
const getTemplate = (raw) => {
  const rawObj = { raw: raw }
  return (...prm) => String.raw(rawObj, ...prm)
}

export const PathInfoList = {
  StaticPage: [
    // 利用規約
    {
      id: 1,
      name: 'TOS',
      pageTile: '利用規約'
    },
    // プライバシーポリシー
    {
      id: 2,
      name: 'PrivacyPolicy',
      pageTile: 'プライバシーポリシー'
    }
  ],
  Objectkeyname: {
    // ご利用ガイド
    guide: 'ご利用ガイド.pdf',
    // news
    news: 'news.csv',
    // notice
    notice: 'notice.csv',
    // uploadGuide
    uploadGuide: 'アップロードガイド.pdf',
    // configFile
    configFile: 'config.json',
    // dashboardFile
    dashboardFile: 'dashboard.json',
    // textSettingFile
    textSettingFile: 'setting.json',
    // uploadTaskConfigFile
    uploadTaskConfigFile: 'upload_task_config.yaml',
    // dashboardGuide
    dashboardGuide: '【参照権限設定参考資料】ダッシュボード一覧.xlsx',
    // dataFileUploadGuide
    dataFileUploadGuide: 'アップロードガイド.pdf',
    // benchmarkCompany
    benchmarkCompany: 'company.csv',
    // recruitmentPlan
    recruitmentPlan: 'recruitment_plan.csv',
    // absenceRate
    absenceRate: 'absence_rate.csv',
    // departmentNameMapping
    departmentNameMapping: 'department_name_mapping.csv',
    // certification
    certification: 'certification.csv',
    //generic mapping config
    genericMappingConfig: 'generic_mapping_config.json',
    //generic task config
    genericTaskConfig: 'generic_task_config.json',
    //generic value convert config
    genericValueConvertConfig: 'generic_value_convert_config.json',
    // employmentType
    employmentType: 'employment_type.csv',
    // genderStatisticsType
    genderStatisticsType: 'gender_statistics_type.csv',
    // employmentTypeSetting
    employmentTypeSetting: 'employment_type_setting.csv',
    // prescribedWorkingHoursMonth
    prescribedWorkingHoursMonth: 'prescribed_working_hours_setting_month.csv',
    // prescribedWorkingHoursYear
    prescribedWorkingHoursYear: 'prescribed_working_hours_setting_year.csv',
    // employeeCountSetting
    employeeCountSetting: 'employee_count_setting.csv',
    //annualIncome
    annualIncomeCalculation: 'annual_income_calculation.csv',
    // codeMaster
    codeMaster: 'code_master.json'
  },
  Folder: {
    // uploadFolder
    uploadFolder: 'web/uploadFile/',
    // uploadGuideFolder
    uploadGuideFolder: 'web/uploadFileGuide/',
    // dashboardFolder
    dashboardFolder: 'web/config/',
    // guideFolder
    guideFolder: 'guide/',
    // newsFolder
    newsFolder: 'news/',
    // noticeFolder
    noticeFolder: 'notice/',
    // textFolder
    textFolder: 'text/',
    // configFolder
    configFolder: 'config/',
    // dataCreationFolder
    dataCreationFolder: 'config/data-creation-task/',
    // benchmarkCompanyFolder
    benchmarkCompanyFolder: 'company/',
    // recruitmentPlanFolder
    recruitmentPlanFolder: 'etl-dataset/recruitment-plan/',
    // absenceRateFolder
    absenceRateFolder: 'qs-dataset/input/absence-rate/',
    // departmentCsv
    departmentCsv: 'standard-format-creation/table/master/department/csv/',
    // departmentCsvDrilldown
    departmentCsvDrilldown: 'standard-format-creation/table/master/department/csv_drilldown/',
    // departmentNameMapping
    departmentNameMapping: 'qs-dataset/input/department-name-mapping/',
    // certificationFolder
    certificationFolder: 'master/certification/',
    // generic upload
    genericUpload: getTemplate`generic-upload/${null}/`,
    // employmentTypeFolder
    employmentTypeFolder: 'master/emp-attribute/employment-type/',
    // genderStatisticsTypeFolder
    genderStatisticsTypeFolder: 'master/dashboard/gender-statistics-type/',
    // employmentTypeSettingFolder
    employmentTypeSettingFolder: 'master/dashboard/employment-type-setting/',
    // prescribedWorkingHoursMonthFolder
    prescribedWorkingHoursMonthFolder: 'master/dashboard/prescribed-working-hours-setting-month/',
    // prescribedWorkingHoursYearFolder
    prescribedWorkingHoursYearFolder: 'master/dashboard/prescribed-working-hours-setting-year/',
    // employeeCountSettingFolder
    employeeCountSettingFolder: 'master/dashboard/employee-count-setting/',
    //annualIncomeFolder
    annualIncomeCalculationFolder: 'master/dashboard/annual-income-calculation/',
    // stdSecondmentFolder
    stdSecondmentFolder: 'qs-dataset/input/std-secondment'
  },
  Resource: {
    // マルチテナント環境参照
    // year_list
    // yearList: "/year_list",
    // kpi
    getKpi: getTemplate`/${null}/kpi`,
    // file_list
    fileList: getTemplate`/${null}/file_list`,
    // file_name_list
    fileNameList: getTemplate`/${null}/file_name_list`,
    // quick_sight_embed_url
    quickSightEmbedUrl: getTemplate`/${null}/quick_sight_embed_url`,
    // download_object
    downloadObject: getTemplate`/${null}/s3_object`,
    // json_object
    jsonObject: getTemplate`/${null}/s3_json`,
    // list
    // s3Select: getTemplate`/${null}/s3_select`,
    // moveToCorporationBucket
    moveToCorporationBucket: getTemplate`/${null}/s3_move_to_corporation_bucket`,
    // getDynamodb
    getDynamodb: getTemplate`/${null}/dynamodb_get`,
    // getAppMaster
    getAppMaster: getTemplate`/${null}/app_master_get`,
    // registDynamodb
    registDynamodb: getTemplate`/${null}/dynamodb_regist`,
    // updateDynamodb
    updateDynamodb: getTemplate`/${null}/dynamodb_update`,
    // createOrUpdateJudgmentRule
    createOrUpdateJudgmentRule: getTemplate`/${null}/update_judgment_rule`,
    // getJudgmentRule
    getJudgmentRule: getTemplate`/${null}/get_judgment_rule`,
    // getJudgmentRuleSubData（プルダウン用データ取得）
    getJudgmentRuleSubData: getTemplate`/${null}/get_judgment_rule_sub_data`,
    // deleteJudgmentRule
    deleteJudgmentRule: getTemplate`/${null}/delete_judgment_rule`,
    // deleteDynamodb
    deleteDynamodb: getTemplate`/${null}/dynamodb_delete`,
    // nextSequene
    nextSequene: getTemplate`/${null}/sequence_next`,
    // getLatestDataSet
    latestDataSet: getTemplate`/${null}/latest_data_set`,
    // uploadFile
    uploadFile: getTemplate`/${null}/upload_file`,
    // getFileUploadTask
    fileUploadTask: getTemplate`/${null}/file_upload_task`,
    // uploadAccountingile
    uploadAccountingFile: getTemplate`/${null}/upload_accounting_file`,
    // getFileUploadTask
    accountingUploadTask: getTemplate`/${null}/accounting_upload_task`,
    // dataCreate
    dataCreate: getTemplate`/${null}/create_data`,
    // dataFix
    dataFix: getTemplate`/${null}/fix_data`,
    // dataFixCancel
    dataFixCancel: getTemplate`/${null}/fix_cancel_data`,
    // get_generic_task_screen (IF02095)
    getGenericTaskScreen: getTemplate`/${null}/get_generic_task_screen`,
    // copy_previous_mapping_bulk (IF02096)
    copyPreviousMappingBulk: getTemplate`/${null}/copy_previous_mapping_bulk`,
    // start_generic_data_validation_bulk (IF02097)
    startGenericDataValidationBulk: getTemplate`/${null}/start_generic_data_validation_bulk`,
    // getUserList
    getUserList: getTemplate`/${null}/get_user_list`,
    // getEmail
    getEmail: getTemplate`/${null}/get_email`,
    // getDataCreateTask
    getDataCreateTask: getTemplate`/${null}/datacreatetask_get`,
    // get_all_chrofy_columns (IF02090)
    getAllChrofyColumns: getTemplate`/${null}/get_all_chrofy_columns`,
    // get_generic_mapping_list (IF02091)
    getGenericMappingList: getTemplate`/${null}/get_generic_mapping_list`,
    // getGroupCompany
    getGroupCompany: getTemplate`/${null}/get_group_company`,
    // getBenchmarkCompany
    getBenchmarkCompany: getTemplate`/${null}/get_benchmark_company`,
    // getIndustrySector
    getIndustrySector: getTemplate`/${null}/get_industry_sector`,
    // getNewGraduate
    getNewGraduate: getTemplate`/${null}/get_new_graduate`,
    // updateNewGraduate
    updateNewGraduate: getTemplate`/${null}/update_new_graduate`,
    // updateRecruitmentPlan
    updateRecruitmentPlan: getTemplate`/${null}/update_recruitment_plan`,
    // updateAbsenceRate
    updateAbsenceRate: getTemplate`/${null}/update_absence_rate`,
    // updateDepartmentHierarchy
    updateDepartmentHierarchy: getTemplate`/${null}/update_department_hierarchy`,
    // updateDepartmentAssociation
    updateDepartmentAssociation: getTemplate`/${null}/update_department_association`,
    // get_department_info (IF02074)
    getDepartmentInfo: getTemplate`/${null}/get_department_info`,
    // get_department_hierarchy (IF02075)
    getDepartmentHierarchy: getTemplate`/${null}/get_department_hierarchy`,
    // update_department_info (IF02072)
    updateDepartmentInfo: getTemplate`/${null}/update_department_info`,
    // delete_department_data (IF02073)
    deleteDepartmentData: getTemplate`/${null}/delete_department_data`,
    //getFilterableDepartmentList
    getQuickSightControlInfo: getTemplate`/${null}/get_quicksight_control_info`,
    //updateCertification
    updateCertificationMaster: getTemplate`/${null}/update_certification_master`,
    //updateCertificationSet
    updateCertificationSet: getTemplate`/${null}/update_certificationset`,
    //getGenericUploadTaskList
    listGenericUploadTask: getTemplate`/${null}/list_generic_upload_task`,
    //deleteGenericUploadTaskList
    deleteGenericUploadTask: getTemplate`/${null}/delete_generic_upload_task`,
    //getGenericUploadTaskList
    getGenericUploadTask: getTemplate`/${null}/get_generic_upload_task`,
    //createGenericUploadTaskList
    createGenericUploadTask: getTemplate`/${null}/create_generic_upload_task`,
    //updateGenericUploadTaskList
    updateGenericUploadTask: getTemplate`/${null}/update_generic_upload_task`,
    // getGenericUploadTaskStatusAll
    getGenericUploadTaskStatusAll: getTemplate`/${null}/get_generic_upload_task_status_all`,
    //getJsonFromCommonBucket
    getJsonFromCommonBucket: getTemplate`/${null}/get_json_from_common_bucket`,
    // getS3PresignedUrl
    getS3PresignedUrl: getTemplate`/${null}/generate_s3_presigned_url`,
    //updateGroupCompanyInfo
    updateGroupCompanyInfo: getTemplate`/${null}/update_group_company_info`,
    //getGroupCompanyInfo
    getGroupCompanyInfo: getTemplate`/${null}/get_group_company_info`,
    // updateEmployeeCount
    updateEmployeeCount: getTemplate`/${null}/update_employee_count`,
    //updateAnnualIncomeCalculation
    updateAnnualIncomeCalculation: getTemplate`/${null}/update_annual_income_calculation`,
    // getStandardFormatUsageItems
    getStandardFormatUsageItems: getTemplate`/${null}/get_standard_format_usage_items`,
    //getDashboardMessages
    getDashboardMessages: getTemplate`/${null}/get_dashboard_messages`,
    //getDashboardMessages
    getSecuritiesReport: getTemplate`/${null}/get_securities_report`,
    // IF02103: 有価証券報告書集計情報取得
    getSecuritiesReportSummary: getTemplate`/${null}/get_securities_report_summary`,
    //getDashboardMessages
    updateSecuritiesReport: getTemplate`/${null}/update_securities_report`,
    // getLegalDisclosure
    getLegalDisclosure: getTemplate`/${null}/get_legal_disclosure`,
    // updateLegalDisclosure
    updateLegalDisclosure: getTemplate`/${null}/update_legal_disclosure`,
    // updateCategory
    updateCategory: getTemplate`/${null}/update_category`,
    //updateCompanyInfo
    updateCompanyInfo: getTemplate`/${null}/update_company_info`,
    // updateSegment
    updateSegment: getTemplate`/${null}/update_segment`,
    // getDataClassificationItems
    getDataClassificationItems: getTemplate`/${null}/get_data_classification_items`,
    // getDataClassifications
    getDataClassifications: getTemplate`/${null}/get_data_classifications`,
    // updateDataClassificationItems
    updateDataClassificationItems: getTemplate`/${null}/update_data_classification_items`,
    // updateGenericTaskFiles (FileManagement: IF2080 汎用マッピングファイル管理更新)
    updateGenericTaskFiles: getTemplate`/${null}/update_generic_task_files`,
    // updateFileClassification (FileManagement: IF2079 ファイル種別情報更新)
    updateFileClassification: getTemplate`/${null}/update_file_classification`,
    // getFileClassification (FileManagement: IF020100 ファイル種別取得)
    getFileClassification: getTemplate`/${null}/get_file_classification`,
    // IF02102: 変換表一覧取得
    listConversionTables: getTemplate`/${null}/list_conversion_tables`,
    // IF02077: 変換項目取得
    getConversionValues: getTemplate`/${null}/get_conversion_values`,
    // IF02076: 変換項目更新判定
    checkConversionTableItems: getTemplate`/${null}/check_conversion_table_items`,
    // IF02071: 変換項目更新
    updateConversionValues: getTemplate`/${null}/update_conversion_values`,
    // IF02081: 変換表削除
    deleteConversionTable: getTemplate`/${null}/delete_conversion_table`,
    // IF02082: 変換表更新
    updateConversionTable: getTemplate`/${null}/update_conversion_table`,
    // 汎用マッピング（IF02083〜IF02088, IF02099 get_mapping_preview_result）
    getGenericTaskMetaInfo: getTemplate`/${null}/get_generic_task_meta_info`,
    getGenericTaskFileClassification: getTemplate`/${null}/get_generic_task_file_classification`,
    getGenericTaskSetting: getTemplate`/${null}/get_generic_task_setting`,
    getDataValidationResult: getTemplate`/${null}/get_data_validation_result`,
    startDataValidationResult: getTemplate`/${null}/start_data_validation_result`,
    updateGenericTaskSetting: getTemplate`/${null}/update_generic_task_setting`,
    getMappingPreview: getTemplate`/${null}/get_mapping_preview_result`,
    // get_generic_task_files (IF02101)
    getGenericTaskFiles: getTemplate`/${null}/get_generic_task_files`,
    // get_previous_file_settings (IF02104 過去タスクファイル設定取得)
    getPreviousFileSettings: getTemplate`/${null}/get_previous_file_settings`,
    // IF02098: データ更新タスク情報取得
    getDataUpdateTaskInfo: getTemplate`/${null}/get_data_update_task_info`,
    // CHROFY環境参照
    // get_object
    getObject: `/s3_csv`,
    // download_object
    downloadCommonObject: `/s3_object`
  }
}
